@if (showLogin) {
  <p-card [style]="{ width: '25rem', overflow: 'hidden' }">
    <ng-template #header>
      <img alt="Card" class="w-full" src="https://primefaces.org/cdn/primeng/images/card-ng.jpg" />
    </ng-template>
    <!--  <ng-template #title> Advanced Card </ng-template>-->
    <!--  <ng-template #subtitle> Card subtitle </ng-template>-->
    <p>
      You must first log in in order to access the application.
    </p>
    <ng-template #footer>
      <div class="flex gap-4 mt-1">
        <p-button (onClick)="loginWithOkta()"
                  label="Login with Okta" class="w-full" styleClass="w-full" />
      </div>
    </ng-template>
  </p-card>
} @else {
  <div class="flex justify-center items-center h-[200px]">
    <p-progressSpinner styleClass="w-8 h-8" strokeWidth="4"></p-progressSpinner>
  </div>
}
